import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { ToggleProps } from "./Toggle.types";

const Toggle = forwardRef<HTMLInputElement, PropsWithChildren<ToggleProps>>(
  ({ className, onChange, ...toggleProps }, forwardedRef) => {
    return (
      <input
        ref={forwardedRef}
        type="checkbox"
        className={cn(
          "relative h-6 w-11 cursor-pointer rounded-full border-transparent bg-neutral-400 p-px text-transparent transition-all duration-200 ease-in-out",
          "before:translate-x before:inline-block before:size-5 before:transform before:rounded-full before:bg-white before:shadow before:transition before:duration-200 before:ease-in-out",
          "checked:border-primary checked:bg-none checked:text-primary checked:before:translate-x-full checked:before:bg-white",
          "focus:outline focus:outline-1 focus:outline-primary focus:ring-0 focus:ring-offset-0 focus:checked:border-primary disabled:pointer-events-none disabled:opacity-50",
          className,
        )}
        onChange={(event) => {
          if (onChange) onChange(event.currentTarget.checked);
        }}
        {...toggleProps}
      />
    );
  },
);

Toggle.displayName = "Toggle";

export default Toggle;
